/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2018
 */

/**
 * NexleaderNewLicenseDiscountModalComponent
 *
 * modal form to create a new LicenseDiscount (see LicenseDiscount.model on the backend)
 *
 * Called by NexleaderLicenseDiscountsComponent
 */

import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { catchError, of, tap } from 'rxjs';
import { ErrorHandlerService } from '../../../../../services/error-handler.service';
import { SuccessService } from '../../../../../services/success.service';
import { LicenseDiscountService } from '../../../resources/license-discount.service';

@Component({
  selector: 'app-nexleader-new-license-discount-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './new-license-discount-modal.component.html',
})
export class NexleaderNewLicenseDiscountModalComponent {
  // yyyy-mm-dd from the date input; the code stays valid through the end of this day
  lastDayValid: string = '';

  licenseDiscount: {
    name: string;
    faithBasedPrice: number | null;
    valuesBasedPrice: number | null;
  } = {
      name: '',
      faithBasedPrice: null,
      valuesBasedPrice: null,
    };

  constructor(
    private licenseDiscountService: LicenseDiscountService,
    private errorHandlerService: ErrorHandlerService,
    private successService: SuccessService,
    private modalService: BsModalService
  ) { }

  save(): void {
    if (!this.licenseDiscount.name.trim())
      return this.errorHandlerService.toast({
        message: 'Please enter a discount code.',
      });
    if (
      typeof this.licenseDiscount.faithBasedPrice !== 'number' ||
      typeof this.licenseDiscount.valuesBasedPrice !== 'number'
    )
      return this.errorHandlerService.toast({
        message: 'Please enter both a faith-based and a values-based price.',
      });

    this.licenseDiscountService
      .save({
        ...this.licenseDiscount,
        expiresAt: this.lastDayValid
          ? new Date(`${this.lastDayValid}T23:59:59`).toISOString()
          : undefined,
      })
      .pipe(
        tap(() => {
          this.successService.handle({
            message: 'Successfully created license discount code.',
          });
          this.modalService.hide();
        }),
        catchError((error) => {
          this.errorHandlerService.handleError(error);
          return of(null);
        })
      )
      .subscribe();
  }
}
